module.exports = __webpack_public_path__ + "img/target5.eef82cdb.jpg";